import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface FilterOptions {
  startDate?: string;
  endDate?: string;
  sourceId?: string;
}

export interface DataSourceOption {
  id: string;
  label: string;
}

@Component({
  selector: 'app-data-visualization-filters',
  templateUrl: './data-visualization-filters.component.html',
  styleUrls: ['./data-visualization-filters.component.scss'],
  standalone: false,
})
export class DataVisualizationFiltersComponent {
  @Input() startDate?: string;
  @Input() endDate?: string;
  @Input() sourceId?: string = 'all';
  @Input() sourceOptions: DataSourceOption[] = [];

  @Output() filtersChanged = new EventEmitter<FilterOptions>();

  get currentLang(): string { return this.translate.currentLang || this.translate.defaultLang || 'en'; }

  constructor(private translate: TranslateService) {}

  onFilterChange() {
    this.filtersChanged.emit({
      startDate: this.startDate,
      endDate: this.endDate,
      sourceId: this.sourceId
    });
  }
}
